module.exports = __webpack_public_path__ + "img/naya.fecd6f1d.png";